@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto">
    <!--
    Title on its own line, controls in normal flow beneath it. The toolbar used to be floated
    and pulled back up onto the title's line with a negative margin and a fixed left offset,
    which only fitted a title shorter than that offset - this one ran straight into the dates.
    Wraps rather than overlapping when the window is narrow.
    -->
    <h3 style="margin: 18px 0 12px 0;" i18n>Booking Questions for period:</h3>
    <div style="display: flex; flex-wrap: wrap; align-items: flex-end; gap: 20px; margin-bottom: 20px;">
      <div style="width: 200px;">
        <span>From Date:</span>
        <p-datepicker [selectOtherMonths]="true" [(ngModel)]="FromDate" (onSelect)="fromDateChanged()" (onInput)="fromDateChanged()" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true"></p-datepicker>
      </div>
      <div style="width: 200px;">
        <span>To Date:</span>
        <p-datepicker [selectOtherMonths]="true" [(ngModel)]="ToDate" [minDate]="FromDate" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true"></p-datepicker>
      </div>
      <div style="width: 400px; max-width: 100%;">
        <span>Tags:</span><br>
        <p-multiselect [options]="tags" optionLabel="name" [(ngModel)]="chosentags" display="chip" [style]="{'width': '100%'}">
          <ng-template let-value #selecteditems>
            @for (tag of chosentags; track tag) {
              <span>
                <p-chip class="mr-2" label="{{tag.name}}" [style]="{'background': tag.colour, 'color': 'white', 'border-radius': '5px' }">
                </p-chip>
              </span>
            }
            @if (!chosentags || chosentags.length === 0) {
              <div class="country-placeholder"> Select Tag(s) </div>
            }
          </ng-template>
        </p-multiselect>
      </div>
      <div style="display: flex; align-items: center; gap: 8px;">
        <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto" style="background-color: #22C55E;border-color: #22C55E;" (click)="doneDate()">
          Go
        </button>
        @if (ListBookingsGlobal) {
          <button
            type="button"
            pButton
            pRipple
            (click)="bookingsTable.exportCSV()"
            pTooltip="Export to CSV"
            tooltipPosition="bottom" [iconOnly]="true"><span class="p-button-icon pi pi-file-excel" aria-hidden="true"></span></button>
          }
        </div>
      </div>
      <div class="surface-card p-4 shadow-2 border-round">
        <p-table  #bookingsTable
          [columns]="cols"
          [value]="ListBookingsGlobal"
          responsiveLayout="scroll"
          [selectionPageOnly]="true">
          <ng-template #header let-columns>
            <tr>
              @for (col of columns; track col) {
                <th [style.text-align]="isAdmissionColumn(col.field) ? 'center' : null">
                  {{ col.header }}
                </th>
              }
            </tr>
          </ng-template>
          <ng-template #body let-rowData let-columns="columns">
            <tr>
              @for (col of columns; track col) {
                <td [style.text-align]="isAdmissionColumn(col.field) ? 'center' : null">
                  @if (col.header != 'Total' && col.header != 'Guests' && col.header != 'Outstanding') {
                    <span >{{ rowData[col.field] }}</span>
                  }
                  @if (col.header == 'Total') {
                    <span style="text-align: right; width:100%">{{ rowData[col.field]  | currency: (rowData.currency || CurrencySymbol) }}</span>
                  }
                  @if (col.header == 'Guests') {
                    <span style="text-align: right; width:100%">{{ rowData[col.field]}}</span>
                  }
                  @if (col.header == 'Outstanding') {
                    <span style="text-align: right; width:100%">{{ rowData[col.field]  | currency: (rowData.currency || CurrencySymbol) }}</span>
                  }
                </td>
              }
            </tr>
          </ng-template>
          <ng-template  #footer>
            <!-- One cell per column, so each total sits under its own column however many
            admission types the period turns up. -->
            @if (ListBookingsGlobal != null && ListBookingsGlobal.length > 0) {
              <tr>
                @for (col of cols; track col) {
                  <td [style.text-align]="isAdmissionColumn(col.field) ? 'center' : null">
                    @if (isAdmissionColumn(col.field)) {
                      <b>{{admissionTotals[col.field]}}</b>
                    }
                    @if (col.header == 'Guests') {
                      <b>{{guests}}</b>
                    }
                    @if (col.header == 'Total') {
                      <b>{{total | currency: CurrencySymbol}}</b>
                    }
                    @if (col.header == 'Outstanding') {
                      <b>{{outstanding | currency: CurrencySymbol}}</b>
                    }
                  </td>
                }
              </tr>
            }
            @if (ListBookingsGlobal != null && ListBookingsGlobal.length == 0) {
              <tr>
                <td style="text-align: center;" colspan="199">
                  There is no data for the selected dates.
                </td>
              </tr>
            }
          </ng-template>
        </p-table>
      </div>
    </div>
  }

